import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { AccessKey } from "./catalog";

const BUILT_IN: Record<string, string> = { club: "Investor's Club", manager_training: "Manager Training", courses: "Courses" };

/** A readable name for an access key when the list hasn't loaded: "course:mhp-masterclass" becomes "Course: mhp masterclass". */
export function fallbackAccessName(key: string): string {
  if (BUILT_IN[key]) return BUILT_IN[key];
  const m = /^course:(.+)$/.exec(key);
  if (m) return `Course: ${m[1].replace(/[-_]/g, " ")}`;
  return key.replace(/_/g, " ");
}

/** Names for access keys (access_keys_list: club, manager_training, course:<slug>), shared by every screen that shows access. */
export function useAccessNames(): (key: string) => string {
  const q = useQuery({ queryKey: ["access-keys"], queryFn: () => api<{ keys: AccessKey[] }>("/api/v1/access-keys"), staleTime: 300_000 });
  const names = new Map((q.data?.keys ?? []).map((k) => [k.key, k.name]));
  return (key: string) => BUILT_IN[key] ?? (names.get(key) || fallbackAccessName(key));
}
